<template>
  <div id="landing" class="has-background-grey-darker">
    <sign-up-candidate-modal
      :modal-is-active="candidateSignUpIsActive"
      @toggleModal="toggleCandidateSignUp"
    />
    <sign-up-company
      :modal-is-active="companySignUpIsActive"
      transition="expand"
      @toggleModal="toggleCompanySignUp"
    />
    <nav-bar-top />
    <!-- HERO VIDEO/IMAGE -->
    <home-page-hero>
      <div class="hero-body container columns">
        <div class="column is-6-desktop">
          <h2
            class="title is-2 is-size-3-mobile is-size-4-mobile tagline"
            style="margin-bottom: 0;"
          >
            Off the Record
          </h2>
          <h2 class="title is-2 is-size-3-mobile is-size-4-mobile tagline">
            On the Market.
          </h2>
          <p class="is-size-4 subtitle is-size-6-mobile tagline" style="margin-top: 0.5rem; line-height: 1.5;">
            The only 100% anonymous job platform
          </p>
          <div class="columns">
            <div class="column has-text-centered">
              <button
                class="button is-rounded is-primary is-large"
                @click="toggleCandidateSignUp"
              >
                <div>
                  <p>I Have Talent</p>
                  <span class="is-block is-size-7">Candidates</span>
                </div>
              </button>
            </div>
            <div class="column has-text-centered">
              <button
                class="button is-rounded is-primary is-large"
                @click="toggleCompanySignUp"
              >
                <div>
                  <p>I Need Talent</p>
                  <span class="is-block is-size-7">Companies</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </home-page-hero>
    <app-footer />
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import SignUpCandidateModal from '@/components/SignUp/SignUpCandidateModal';
import SignUpCompany from '@/components/SignUp/SignUpCompanyModal';
import HomePageHero from '@/components/HomePageHero';
import AppFooter from '@/components/AppFooter';

export default {
  name: 'Home',
  components: {
    NavBarTop,
    SignUpCandidateModal,
    SignUpCompany,
    HomePageHero,
    AppFooter
  },
  data () {
    return {
      candidateSignUpIsActive: false,
      companySignUpIsActive: false
    };
  },
  methods: {
    toggleCandidateSignUp () {
      this.candidateSignUpIsActive = !this.candidateSignUpIsActive;
    },
    toggleCompanySignUp () {
      this.companySignUpIsActive = !this.companySignUpIsActive;
    }
  }
};
</script>

<style lang="scss" scoped>
.button.is-large {
  height: 3.25em;
  padding-left: 2rem;
  padding-right: 2rem;
  font-weight: bold;
}

.hero.is-primary {
  background-color: rgba($white-ter, 0.5);
  height: 100vh;
}

.hero-body {
  flex-grow: 0;
  margin-left: 0!important;
  margin-top: 4rem;

  @media screen and (max-width: 767px) {
    margin-left: 0!important;
    margin-top: 4rem!important;
  }
}

.columns {
  margin: auto;
}

.subtitle.tagline {
  padding-bottom: 2rem;
}

@media screen and (min-width: 1088px) {
  .section.is-large {
    padding: 1rem 1.5rem;
  }
}

@media screen and (max-width: 1088px) {
  .container {
    margin: 0;
  }
}

.line-space-tall {
  line-height: 2.25rem;
}

.title sup,
.subtitle sup {
  font-size: 0.75em;
}

.subtitle:not(:last-child) {
  margin-bottom: 0.5rem;
}

.is-invisible {
  opacity: 0 !important;
}

// vertically center demo
html {
  display: table;
  height: 100%;
  width: 100%;
}

body {
  display: table-cell;
  vertical-align: middle;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.tagline {
  font-family: "Montserrat Alternates";
}
</style>
